import Card from '../../Shared/Cards/FeatureCard/Card';
import { prototype } from './data';

import '../Wireframe/Styles/Features.scss';
function Features(){
    return(
        <div className="wireframe-features">
          {prototype.map((d) =>{
              return(
                  <Card {...d}/>
              )
          })}
        </div>
    )
};
export default Features ;